import { chunk, compact, isEmpty } from 'lodash';

export type TokenGroup = {
    token: string;
    elementIds: string[];
};

/**
 * Ensures that each group of elements is less than
 */
export const getTokenElementBatches = (tokenGroups: TokenGroup[]): TokenGroup[] => {
    const groups: TokenGroup[] = [];

    tokenGroups.forEach(({ token, elementIds }) => {
        const elementIdBatches = chunk(elementIds, 200);

        elementIdBatches.forEach((elementIdBatch) => {
            if (isEmpty(compact(elementIdBatch))) return;
            groups.push({ token, elementIds: elementIdBatch });
        });
    });

    return groups;
};
